module.exports = __webpack_public_path__ + "assets/img/block-right-789448d2.png";